const {track,range,pinned,clamp}=require('./scroll-driver.js');
document.querySelectorAll('[data-signature]').forEach(section=>{
 const viewport=section.querySelector('.one-signature__viewport');
 const layers=[...section.querySelectorAll('[data-signature-layer]')],phases=[...section.querySelectorAll('[data-signature-phase]')];
 const counter=section.querySelector('[data-signature-count]');
 track(section,data=>{
  const progress=pinned(data.rect,data.height),timeline=range(progress,.05,.95)*3,index=Math.min(2,Math.floor(timeline));
  layers.forEach((layer,i)=>{
   const enter=i===0?1:range(timeline,i-.18,i+.14);
   layer.style.setProperty('--layer-opacity',String(enter));
   layer.style.setProperty('--layer-inset',`${(1-enter)*100}%`);
   layer.style.setProperty('--layer-scale',String(1.06-.06*enter));
  });
  phases.forEach((phase,i)=>{phase.classList.toggle('is-current',i===index);phase.style.setProperty('--phase-fill',String(clamp(timeline-i)));});
  section.style.setProperty('--wire-dash',String(5000*(1-range(progress,0,.24))));
  counter.textContent=String(index+1).padStart(2,'0');
 },()=>({rect:section.getBoundingClientRect(),height:viewport.offsetHeight}),()=>section.style.removeProperty('--wire-dash'));
});
